module.exports = __webpack_public_path__ + "static/media/privateGroup.3546b3b8.svg";